import React from 'react';
import PageBanner from '../components/PageBanner/PageBanner';
import ampsmotor from '../assets/images/ampsmotor.jpg';
import eiffelBlack from '../assets/images/eiffel-black.jpg';
import './About.css';

const HONOUR_CODE = [
  'Always uphold the name of my university.',
  'Make my Residence my pride.',
  'Keep my demeanour loyal.',
  'Know my duty.',
  'Grasp my opportunities.',
  'Respect my betters.',
  'Be an example to those who look up to me.',
  'Esteem my neighbour as I do myself.',
];

const RULES = [
  'No alcohol or illegal drugs are allowed in personal rooms, including cannabis.',
  'All residence members are subject to the residence rules and disciplinary policy of the University of Pretoria.',
  'Silence must be maintained in and around the residence between 22:00 and 06:00.',
  'No flooding of rooms or corridors is allowed.',
  'No resident may bring the name of House TAU or the University of Pretoria into jeopardy.',
  'Residence placement for the following academic year is based on first-semester marks.',
  'No racism or hate speech will be tolerated; disciplinary action follows as a corrective measure.',
];

export default function About() {
  return (
    <>
      <PageBanner
        image="/gallery/full/event-013.jpg"
        eyebrow="Est. 1963 · University of Pretoria"
        title="The House"
        subtitle='Built on brotherhood, tradition, and the pursuit of excellence. "Iron Sharpens Iron" has carried every generation of Ysters since the beginning.'
        height="lg"
      />

      <section className="section">
        <div className="container">
          <p className="section__eyebrow">Stewards of Tradition</p>
          <h2 style={{ marginBottom: 'var(--space-lg)' }}>Those Who Watch Over the House</h2>

          <div className="leadership-grid">
            <div className="info-card">
              <h3>The House Parents</h3>
              <p className="prose">
                House TAU is currently under the care of <strong>Dr Bernard Coetzee</strong> and{' '}
                <strong>Tannie Hanrie Coetzee</strong>, who lead the House as Heads of Residence.
                Together with the House Committee, they look after the wellbeing, growth, and
                traditions of every resident, from the moment a first-year arrives to the day
                they graduate as a House TAU alumnus.
              </p>
            </div>

            <div className="info-card">
              <h3>The Building Coordinator</h3>
              <p className="prose">
                Day-to-day maintenance and building queries are handled by Tannie Charmaine, the
                House's Building Coordinator, the first port of call if something needs fixing,
                available on weekdays during office hours.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section section--alt">
        <div className="container">
          <p className="section__eyebrow">Our emblems</p>
          <h2 style={{ marginBottom: 'var(--space-lg)' }}>House TAU Emblems</h2>

          <div className="emblem-block">
            <div className="emblem-block__media">
              <img src={eiffelBlack} alt="The House TAU Eiffel Tower" />
            </div>
            <div className="emblem-block__text">
              <h3>The Eiffel</h3>
              <p>
                The four legs of the Eiffel symbolise pride, tradition, respect, and
                brotherhood: the core values that define a House TAU gentleman.
              </p>
              <p>
                The first Eiffel was "donated" to House TAU by a group of day students,
                without their prior knowledge or consent. It was originally placed on the
                House roof for all to admire, but after life-threatening hijacking attempts,
                it was moved to the quad in 1964, where it still stands tall and proud today.
              </p>
              <p>
                Over the decades there have been multiple attempts to take the Eiffel from
                House TAU: it has been melted, sawn, painted, dug out, and welded, but
                after all these years, it still stands strong.
              </p>
            </div>
          </div>

          <div className="emblem-block emblem-block--reverse">
            <div className="emblem-block__media">
              <img src={ampsmotor} alt="The House TAU Ampsmotor" />
            </div>
            <div className="emblem-block__text">
              <h3>The Ampsmotor</h3>
              <p>
                In 1978, House TAU became the proud owner of the stately "Ampsmotor", a
                1960 Rover, spotted buried under decades of cobwebs and dust in someone's
                backyard by an old House chairman. Its potential was recognised, and after
                extensive negotiations it was voluntarily donated to House TAU, where it
                remains a proud part of House tradition today.
              </p>
              <p>
                Decades later, the Ampsmotor is still parked proudly on the property, a
                fixture in House photos and a favourite backdrop for Ysters marking their
                time at TAU. It has outlasted generations of residents without ever leaving
                home.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <p className="section__eyebrow">Values</p>
          <h2>Code of Honour</h2>
          <p className="prose">As a member of House TAU, I declare that I strive to:</p>
          <ol className="honour-list">
            {HONOUR_CODE.map((line) => (
              <li key={line}>{line}</li>
            ))}
          </ol>
          <p className="prose" style={{ fontStyle: 'italic', color: 'var(--color-text-muted)' }}>
            This, all because I realise that I must recognise authority.
          </p>
        </div>
      </section>

      <section className="section section--alt">
        <div className="container">
          <p className="section__eyebrow">Looking ahead</p>
          <h2>65th Anniversary: Feesjaar 2027</h2>
          <p className="prose">
            2027 marks House TAU's 65th anniversary. Every big milestone comes with its own
            tradition: the Eiffel is repainted gold for the year, with a white transitional
            coat in between the everyday black and the feesjaar gold, which is exactly
            where the House stands right now. Keep an eye on the homepage for the moment the
            coat turns all the way to gold.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <p className="section__eyebrow">Good to know</p>
          <h2>General House Rules</h2>
          <ul className="rules-list">
            {RULES.map((rule) => (
              <li key={rule}>{rule}</li>
            ))}
          </ul>
          <p className="about-note">
            Full rules and regulations are governed by the University of Pretoria's TuksRes
            guide. Residents should also refer to the official First Year Checklist shared by
            the House Committee.
          </p>
        </div>
      </section>
    </>
  );
}
